(function () {
  // const activeTemplates = '.page-template-template-coming-soon, .page-template-template-2020-paid-landing';
  // // Do nothing if not on coming soon page template
  // if (!document.querySelector(activeTemplates) || !document.querySelector('.site-header, .site-content')) {
  //   return;
  // }
  // const siteHeader = document.querySelector('.site-header');
  // const siteContent = document.querySelector('.site-content');
  // const lowerNav = document.querySelector('.lower-nav');
  // const debounce = (func, wait, immediate) => {
  //   var timeout;
  //   return function () {
  //     var context = this,
  //       args = arguments;
  //     var later = function () {
  //       timeout = null;
  //       if (!immediate) func.apply(context, args);
  //     };
  //     var callNow = immediate && !timeout;
  //     clearTimeout(timeout);
  //     timeout = setTimeout(later, wait);
  //     if (callNow) func.apply(context, args);
  //   };
  // };
  // const setHeaderPadding = debounce(() => {
  //   if (lowerNav && lowerNav.style.height !== '0') {
  //     // lowerNav.style.height = '0';
  //   }
  //   const sitePaddingTop = siteHeader.offsetHeight;
  //   siteContent.style.paddingTop = sitePaddingTop + 'px';
  // }, 250);
  // const updatePadding = () => {
  //   const viewport = window.innerWidth || document.documentElement.clientWidth;
  //   const scrollY = window.scrollY || window.pageYOffset;
  //   if (document.body.classList.contains('lock-position')) {
  //     return;
  //   }
  //   if (viewport <= 767) {
  //     setHeaderPadding();
  //     if (scrollY === 0) {
  //       setHeaderPadding();
  //     }
  //   } else {
  //     siteContent.style.paddingTop = '0';
  //   }
  // };
  // updatePadding();
  // window.addEventListener('resize', updatePadding);
  // window.addEventListener('scroll', updatePadding);
  // window.addEventListener('transitioned', updatePadding);
})();
